import { Box, Text, Grid, GridItem } from "@chakra-ui/react";
import { IconLocationPin } from "../../../styles/icons";

export const sectionStyleEditing2 = {
  bg: "white",
  //borderRadius: '20px',
  width: "100%",
  //marginBottom: '20px',
};

export const profileAccordionButton = {
  bg: "gray.200",
};

export const profileAccordionPanel = {
  width: "100%",
  p: "2px",
  bg: "gray.200",
};

export const renderAvailabilityContent = (
  availabilityLabels,
  availability,
  getNewAvailability = null
) => {
  return (
    <Grid templateColumns="repeat(10, 1fr)" gap={1}>
      {/* titles */}
      <GridItem colSpan={3} w="100%" h="27px" bg="white" />
      {renderColumnHeader("M")}
      {renderColumnHeader("T")} {renderColumnHeader("W")}
      {renderColumnHeader("T")} {renderColumnHeader("F")}
      {renderColumnHeader("S")} {renderColumnHeader("S")}
      {/* availability matrix */}
      {renderAvailabilityMatrix(
        availabilityLabels,
        availability,
        getNewAvailability
      )}
    </Grid>
  );
};

const renderAvailabilityMatrix = (
  availabilityLabels,
  availability,
  getNewAvailability = null
) => {
  //Update availability matrix
  const updateAvailability = (index, idx) => {
    let newArr = availability.map((elem, arrIndex) => {
      return index === arrIndex
        ? elem.map((elem2, idx2) => (idx === idx2 ? !elem2 : elem2))
        : elem;
    });
    getNewAvailability(newArr);
  };

  return (
    <>
      {availability.map((item, index) => {
        return (
          <>
            {renderRowHeader(availabilityLabels[index])}
            {item.map((elem, idx) => (
              <GridItem w="100%" h="27px" key={idx}>
                <Box
                  display="flex"
                  height="100%"
                  width="100%"
                  justifyContent="center"
                  alignItems="center"
                  borderRadius="5px"
                  bg={elem ? "brand.400" : "brand.100"}
                  onClick={() => {
                    if (getNewAvailability !== null)
                      updateAvailability(index, idx);
                  }}
                >
                  <Text textStyle="h6" color="white">
                    {elem ? "\u2714" : ""}
                  </Text>
                </Box>
              </GridItem>
            ))}
          </>
        );
      })}
    </>
  );
};

const renderColumnHeader = (str) => (
  <GridItem w="100%" h="27px" bg="white">
    <Box display="flex" justifyContent="center" alignItems="flex-end">
      <Text textStyle="h6">{str}</Text>
    </Box>
  </GridItem>
);

const renderRowHeader = (str) => (
  <GridItem colSpan={3} w="100%" h="27px" bg="white">
    <Box display="flex" justifyContent="flex-start" alignItems="center">
      <Text textStyle="h6">{str}</Text>
    </Box>
  </GridItem>
);

export const renderAddresses = (distance, addresses, textSize = "footer2") => {
  let jsx = null;
  let distString = "";

  if (
    distance !== null &&
    typeof distance !== "undefined" &&
    distance !== "Unknown"
  ) {
    // distance has been calculated
    let intDist = Number(distance);
    if (intDist < 1) {
      distString = `${(intDist * 1000).toFixed()} m`;
    } else {
      distString = `${intDist.toFixed(2)} km`;
    }
  }

  if (
    distance !== null &&
    typeof distance !== "undefined" &&
    distance !== "Unknown"
  ) {
    jsx = distString;
  } else {
    if (addresses?.length > 0) {
      let cities = addresses
        .map((address) => address.city)
        .filter((city) => city.length > 0);
      if (cities.length === 0) {
        jsx = "Online only";
      } else {
        jsx = [...cities].join(", ");
      }
      //jsx = JSON.stringify(cities);
      // jsx = [...new Set(cities)].join(', ');
    } else {
      // no addresses
      jsx = "Online only";
    }
  }

  return (
    <div className="flex items-center gap-2">
      <IconLocationPin />
      <Text textStyle={textSize}>{jsx}</Text>
    </div>
  );
};
